import { createRoute } from '@tanstack/react-router';

import { ManageUsers } from '../../features/user/manage-users';
import { signInRoute } from '../signin';

export const usersRoute = createRoute({
  getParentRoute: () => signInRoute,
  path: 'users',
  component: ManageUsers,
});
